const Can = ({ permission, yes, no }) => (permission ? yes() : no());

Can.defaultProps = {
  yes: () => null,
  no: () => null,
};

export default Can;
